export const OPEN_ACTION_TARGETS = [3, 2, 1, 1, 1, 1] as const; // Sum = 9 open items total

export const ACTION_TITLE_POOL = [
  // Maintenance & Equipment
  'Tarare rilevatori ammoniaca',
  'Sostituire filtri K',
  'Verificare armadio DPI',
  'Controllare valvole di sicurezza',
  'Taratura scrubber / abbattimento',
  'Verifica tenuta circuito frigorifero',
  'Controllo livello vasca abbattimento',
  'Manutenzione estrattori aria',
  // Documentation & Compliance
  'Aggiornare piano di emergenza',
  'Ripristinare cartellonistica di sicurezza',
  'Allineare registro manutenzioni',
  'Aggiornare schede sicurezza',
  'Archiviare certificati calibrazione',
  'Aggiornare planimetrie evacuazione',
  // Training & Certifications
  'Rinnovo patentino frigoristi',
  'Formazione antincendio',
  'Aggiornamento primo soccorso',
  'Formazione rischio ammoniaca',
  'Prova evacuazione programmata',
  // Scheduling & Reminders
  'Programmare prossima ispezione',
  'Richiedere preventivo manutenzione',
  'Confermare data sopralluogo',
  'Inviare report finalizzato',
  // Administrative
  'Rinnovo CPI',
  'Aggiornamento autorizzazione',
  'Verifica scadenza polizza',
  'Contattare servizio reperibilità',
] as const;

export const LEAK_SOURCES = [
  'personale_patentato',
  'societa_esterna',
  'rilevatori_allarme',
] as const;

export const LEAK_RESOLUTIONS = ['risolto', 'non_risolto', 'n_a'] as const;

export const COMPLIANCE_STATES = ['conforme', 'non_conforme'] as const;

export const READINESS_STATES = ['corretta', 'non_corretta'] as const;

export const FILTER_TYPES = ['k1', 'k2', 'k3'] as const;

export const FILTER_VALENCES = ['monovalente', 'polivalente'] as const;

export const FILTER_CAPACITIES = ['s', 'm', 'l'] as const;

export const SENSOR_STATUS = ['attivi', 'non_attivi'] as const;

export const SHUTOFF_TYPES = ['presente', 'deviatore', 'non_presente'] as const;

export const SELECTOR_STATES = ['auto', 'man', 'off'] as const;

export const ACTIVATION_METHODS = ['manuale', 'da_rilevatore'] as const;

export const DIALER_STATES = ['attivo', 'non_attivo', 'non_presente'] as const;

export const EXIT_ROUTE_STATES = ['conformi', 'non_conformi'] as const;

export const VALVE_CONTROL_STATES = ['presenti', 'non_presenti'] as const;

export const DETAILED_VERIFIERS = ['DT', 'PP', 'RP'] as const;

export const SIGNAGE_STATES = ['conforme', 'integrare', 'non_conforme'] as const;

export const FIRST_AID_STATES = ['conforme', 'non_presente', 'non_conforme'] as const;

export const ALARM_PANEL_STATES = ['accesa', 'non_accesa'] as const;

export const TERNARY_COMPLIANCE = ['conforme', 'non_conforme', 'n_a'] as const;

export const SCBA_REGULATOR_TYPES = ['monopulsante', 'doppio_pulsante'] as const;

export const DETAILED_CHECK_LIBRARY = [
  'Locale macchine - Cartellonistica',
  'Vasca abbattimento - Livello',
  'Compressori - Registro interventi',
  'Piano emergenza - Presidio',
  'Sistema rilevazione - Test funzionale',
] as const;
